<template>
  <div class="documents-details">
    <div v-if="headline" class="headline">{{ headline }}</div>
    <div v-if="description" class="description">{{ description }}</div>
  </div>
</template>

<script>
export default {
  props: {
    headline: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.documents-details {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-1;

  .headline {
    @include bb-titles-styles('xs');
  }

  .description {
    @include bb-regular-text-styles('sm');
    color: $bb-neutral-2;
  }
}
</style>
